/**
 * 全局注册组件插件
 * 用于注册常用的全局组件，如优化的图片组件
 */
import OptimizedImage from '~/components/OptimizedImage.vue';

export default defineNuxtPlugin((nuxtApp) => {
  // 注册优化的图片组件
  nuxtApp.vueApp.component('OptimizedImage', OptimizedImage);
}); 